import { axiosInstance } from "../../client";

export function getSeasons(page = 1, pageSize = 10, search = "", includeDeleted = false) {
  return axiosInstance.get(`Seasons`, {
    params: { page, pageSize, search, includeDeleted },
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}
export const createSeason = async (payload) => (await axiosInstance.post("Seasons", payload)).data;
export const updateSeason = async (id, payload) => (await axiosInstance.put(`Seasons/${id}`, payload)).data;
export const deleteSeason = async (id) => (await axiosInstance.delete(`Seasons/${id}`)).data;
export const restoreSeason = async (id) => (await axiosInstance.post(`Seasons/${id}/restore`)).data;


export function getSeasonsAll(page?: number, pageSize?: number, search = "", includeDeleted = false) {
  const params: Record<string, any> = { search, includeDeleted };
  if (page !== undefined && pageSize !== undefined) {
    params.page = page;
    params.pageSize = pageSize;
  }

  return axiosInstance.get(`Seasons`, {
    params,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export const getSeasonsPerSupplier = (supplierId) => {
  return axiosInstance.get(`Seasons/SeasonsPerSupplier/${supplierId}`);
};